(function () {
  var VENDOR_ID = '661';
  var VENDOR_NAME = 'ProSpec';
  var API_SRC = 'https://cdn.bioz.com/assets/bioz-w-api-6.0.min.js';
  var INLINE_SRC = 'https://cdn.bioz.com/assets/bioz-w-inline-badge.min.js';

  function uniqueSkus(raw) {
    var seen = {};
    var out = [];
    String(raw || '')
      .split(',')
      .forEach(function (part) {
        var sku = part.trim().toLowerCase().replace(/\s+/g, '');
        if (sku && !seen[sku]) {
          seen[sku] = true;
          out.push(sku);
        }
      });
    return out;
  }

  function resolveSlug(root) {
    var override = (root.getAttribute('data-bioz-widget') || '').trim();
    if (override) return override;
    var map = window.BIOZ_SKU_MAP || {};
    var skus = uniqueSkus(root.getAttribute('data-bioz-skus'));
    for (var i = 0; i < skus.length; i++) {
      if (map[skus[i]]) return map[skus[i]];
    }
    return '';
  }

  function sanitizeId(catalog) {
    return String(catalog).replace(/[ .]/g, '_');
  }

  function primeEmbedHtml(catalog) {
    var idPart = sanitizeId(catalog);
    var objectId = 'wobj-' + VENDOR_ID + '-' + idPart + '-q';
    var linkId = 'bioz-w-pb-' + VENDOR_ID + '-' + idPart + '-q';
    var widgetUrl = 'https://www.bioz.com/v_widget_6_0/' + VENDOR_ID + '/' + catalog + '/';
    var resultUrl =
      'https://www.bioz.com/result/' + catalog + '/product/' + VENDOR_NAME + '/?cn=' + encodeURIComponent(catalog);

    return (
      '<object id="' +
      objectId +
      '" type="text/html" data="' +
      widgetUrl +
      '" style="width:100%; height: 193px"></object> ' +
      '<div id="' +
      linkId +
      '-div" style="width: 100%">' +
      '<a id="' +
      linkId +
      '" style="font-size: 12px;text-decoration:none;color:#1f2860" href="https://www.bioz.com/" target="_blank">' +
      '<img src="https://cdn.bioz.com/assets/favicon.png" style="display:inline;width:11px;height:11px;vertical-align: baseline;padding-bottom:0px;margin-left:0px;margin-bottom:0px;float:none" alt="powered by bioz" /> Powered by Bioz</a> ' +
      '<a style="font-size: 12px;text-decoration:none;float: right;color:transparent" href="' +
      resultUrl +
      '" target="_blank"> See more details on Bioz</a></div>'
    );
  }

  function loadScriptOnce(src) {
    return new Promise(function (resolve) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.getAttribute('data-bioz-loaded') === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', resolve);
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.onload = function () {
        script.setAttribute('data-bioz-loaded', 'true');
        resolve();
      };
      script.onerror = resolve;
      document.head.appendChild(script);
    });
  }

  function ensureInlineBadgeTarget() {
    if (!document.getElementById('bioz-inline-badge-data')) {
      var holder = document.createElement('div');
      holder.id = 'bioz-inline-badge-data';
      holder.style.display = 'none';
      document.body.appendChild(holder);
    }
  }

  function reveal(panel) {
    var wrapper = panel.closest('.product_tab_wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('.bioz_badge.tab_content').forEach(function (el) {
      el.removeAttribute('hidden');
    });
  }

  function init(panel) {
    var mount = panel.querySelector('[data-bioz-embed]');
    if (!mount || mount.getAttribute('data-bioz-ready') === 'true') return;
    var slug = resolveSlug(panel);
    if (!slug) return;

    mount.innerHTML = primeEmbedHtml(slug);
    mount.setAttribute('data-bioz-ready', 'true');
    reveal(panel);
    ensureInlineBadgeTarget();

    loadScriptOnce(API_SRC).then(function () {
      return loadScriptOnce(INLINE_SRC);
    });
  }

  var waitingForMap = false;
  function start() {
    var panels = document.querySelectorAll('[data-bioz-badge]');
    var needsMap = false;
    panels.forEach(function (panel) {
      if (!(panel.getAttribute('data-bioz-widget') || '').trim()) needsMap = true;
    });
    if (needsMap && !window.BIOZ_SKU_MAP && !waitingForMap) {
      waitingForMap = true;
      window.addEventListener('load', start);
      return;
    }
    panels.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
